import * as React from 'react';
import { Group, Text, createStyles } from '@mantine/core';

// Components
import { EditButton } from '../EditButton';
import { DeleteButton, DeleteButtonProps } from '../DeleteButton';

const useStyles = createStyles((theme) => ({
    cardHeader: {
        padding: '1rem 1.25rem',
        borderBottom: '1px solid #dee2e6',
        position: 'relative',
        zIndex: 1,
        boxShadow: theme.shadows.xs,
        background: theme.fn.variant({ variant: 'light', color: theme.primaryColor }).background,
        color: theme.fn.variant({ variant: 'light', color: theme.primaryColor }).color
        // background: theme.colors.blue[0],
        // color: theme.colors.blue[6]
        // background: theme.colors.orange[0],
        // color: theme.colors.orange[6]
    }
}));

interface CardHeaderProps {
    readOnly?: boolean;
    children: React.ReactNode;
    additionalAction?: React.ReactNode;
    onEdit?: () => void;
    deleteModalProps?: DeleteButtonProps['confirmModalProps'];
}

export const CardHeader: React.FC<CardHeaderProps> = ({
    onEdit,
    deleteModalProps,
    readOnly,
    children,
    additionalAction
}) => {
    const { classes, cx } = useStyles();

    return (
        <Group position="apart" className={classes.cardHeader}>
            <Text fz="md" fw={500}>
                {children}
            </Text>
            <Group>
                {additionalAction ?? null}
                {deleteModalProps ? (
                    <DeleteButton minimal={false} confirmModalProps={deleteModalProps} disabled={readOnly} />
                ) : null}
                {onEdit ? <EditButton minimal={false} onClick={onEdit} disabled={readOnly} /> : null}
            </Group>
        </Group>
    );
};

export default CardHeader;
